(function() {
    BoostPFS.inject(this);
    // Set global variable
    Globals.hasIntegration = true;
    
    // 3rd app compile template (No changes needed here)
    Integration.compileIntegrationTemplate = function(data, itemHtml) {
        var itemReviewsHtml = '<div class="wc_product_review_badge_boostcommerce" data-handle="' + data.handle + '" data-product_id="' + data.id + '"></div>';
        itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);
        return itemHtml;
    };

    // Updated function to call Rivyo V2 API
    Integration.call3rdIntegrationFunc = function(data) {
        var badges = jQ(".wc_product_review_badge_boostcommerce");
        
        if (badges.length > 0) {
            // 1. Get and format the shop domain
            var shopDomain = boostPFSConfig.shop.domain;
            if (shopDomain) {
                shopDomain = shopDomain.replace("https://", "");
            }

            // 2. Collect all unique product IDs
            var productIds = [];
            badges.each(function() {
                var id = jQ(this).data("product_id");
                if (id && productIds.indexOf(id) === -1) {
                    productIds.push(id);
                }
            });

            if (productIds.length === 0) return;

            // 3. Build the new V2 API URL with GET parameters
            var baseUrl = 'https://app.rivyo.com/rivyo-app/V2/get-product-review-ratings';
            var url = new URL(baseUrl);
            url.searchParams.append('shop', shopDomain);
            
            productIds.forEach(function(id, index) {
                url.searchParams.append('product_ids[' + index + ']', id);
            });

            // 4. Fetch data and inject HTML
            fetch(url.toString(), {
                method: 'GET',
                headers: {
                    'Accept': 'application/json, text/plain, */*'
                }
            })
            .then(function(response) {
                if (!response.ok) throw new Error('Rivyo API error: ' + response.status);
                return response.json();
            })
            .then(function(data) {
                var settings = data.setting || {};
                var hideEmpty = parseInt(settings.hide_empty_review) === 1;
                var label = settings.average_review_label || '';
                var color = settings.rating_color ? '#' + settings.rating_color : '#0b0c0e';
                var size = settings.rating_size ? settings.rating_size + 'px' : '14px';

                badges.each(function() {
                    var productId = jQ(this).data("product_id");

                    var matchingRating = data.product_rating.find(function(item) {
                        return item.id && parseInt(item.id, 10) === productId;
                    });
                    
                    if (matchingRating) {
                        var total = parseInt(matchingRating.total_rating) || 0;
                        var avg = parseFloat(matchingRating.avg_rating) || 0;
                        
                        if (total === 0 && hideEmpty) {
                            jQ(this).html(''); 
                            return;
                        }

                        var percent = (avg / 5) * 100;
                        
                        var emptyStarsSvg = settings.star_icon_multiple.replace(/#ffcf47/gi, '#e5e5e5'); 
                        var filledStarsSvg = settings.star_icon_multiple.replace(/#ffcf47/gi, '#000');

                        var badgeHtml = 
                            '<div class="rivyo-custom-built-badge" style="display: flex; align-items: center; gap: 8px; font-size: ' + size + '; color: ' + color + '; line-height: 1; margin-top: 5px;">' +
                                '<div style="position: relative; display: inline-flex;">' +
                                    '<div>' + emptyStarsSvg + '</div>' + 
                                    '<div style="position: absolute; top: 0; left: 0; width: ' + percent + '%; overflow: hidden; white-space: nowrap;">' + filledStarsSvg + '</div>' + 
                                '</div>' +
                                '<div style="padding-top: 2px;">' +
                                    (total > 0 ? '(' + total + ' ' + label + ')' : '') + 
                                '</div>' +
                                
                            '</div>';

                        jQ(this).html(badgeHtml);
                    }
                });
            })
            .catch(function(error) {
                console.error("Failed to fetch Rivyo V2 ratings inside Boost integration:", error);
            });
        }
    }
})();